import { Link } from 'react-router-dom';

const footerLinks = {
  games: {
    title: '热门游戏',
    links: [
      { label: '电子游艺', path: '/categories' },
      { label: '真人荷官', path: '/categories' },
      { label: '体育竞技', path: '/categories' },
      { label: '棋牌桌游', path: '/categories' },
      { label: '捕鱼游戏', path: '/categories' },
    ],
  },
  services: {
    title: '会员服务',
    links: [
      { label: '会员权益', path: '/about' },
      { label: '优惠活动', path: '/articles' },
      { label: '安全保障', path: '/about' },
      { label: '新手指南', path: '/articles' },
      { label: '常见问题', path: '/about' },
    ],
  },
  about: {
    title: '关于我们',
    links: [
      { label: '品牌介绍', path: '/about' },
      { label: '联系我们', path: '/about' },
      { label: '责任博彩', path: '/about' },
      { label: '隐私政策', path: '/about' },
      { label: '服务条款', path: '/about' },
    ],
  },
};

export default function Footer() {
  return (
    <footer className="bg-background-900 text-foreground-300">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
            {/* Brand */}
            <div className="sm:col-span-2 lg:col-span-1">
              <Link to="/" className="flex items-center gap-3 cursor-pointer group mb-4">
                <div className="w-10 h-10 flex items-center justify-center">
                  <i className="ri-planet-line text-3xl text-primary-400"></i>
                </div>
                <span className="font-heading text-xl font-bold text-background-50 whitespace-nowrap">银河娱乐</span>
              </Link>
              <p className="text-sm text-foreground-500 leading-relaxed mb-5">
                银河娱乐官方平台，行业领先的在线娱乐品牌。汇聚海量精品游戏，提供安全可靠的娱乐环境，为全球超过500万会员打造顶级娱乐体验。
              </p>
              <div className="flex items-center gap-4">
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-foreground-400 hover:bg-primary-500 hover:text-background-50 transition-all duration-300 cursor-pointer" aria-label="微信">
                  <i className="ri-wechat-line text-lg"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-foreground-400 hover:bg-primary-500 hover:text-background-50 transition-all duration-300 cursor-pointer" aria-label="微博">
                  <i className="ri-weibo-line text-lg"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-foreground-400 hover:bg-primary-500 hover:text-background-50 transition-all duration-300 cursor-pointer" aria-label="QQ">
                  <i className="ri-qq-line text-lg"></i>
                </a>
              </div>
            </div>

            {/* Links */}
            {Object.values(footerLinks).map((section) => (
              <div key={section.title}>
                <h4 className="font-heading text-base font-semibold text-background-50 mb-5">
                  {section.title}
                </h4>
                <ul className="space-y-3">
                  {section.links.map((link) => (
                    <li key={link.label}>
                      <Link
                        to={link.path}
                        className="text-sm text-foreground-500 hover:text-primary-400 transition-colors duration-200 cursor-pointer"
                      >
                        {link.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          {/* Contact strip */}
          <div className="mt-12 pt-8 border-t border-background-700/60">
            <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
              <div className="flex flex-wrap items-center gap-6 text-sm text-foreground-500">
                <span className="flex items-center gap-2">
                  <i className="ri-phone-line text-primary-400"></i>
                  400-888-8888
                </span>
                <span className="flex items-center gap-2">
                  <i className="ri-mail-line text-primary-400"></i>
                  service@galaxyentertainment.com
                </span>
                <span className="flex items-center gap-2">
                  <i className="ri-time-line text-primary-400"></i>
                  7×24小时在线
                </span>
              </div>
              <p className="text-xs text-foreground-600">
                © 2010-2026 银河娱乐官方平台 版权所有
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}